import Dropdown from 'components/formComponents/Base/Dropdown';
import TextBlock from 'components/formComponents/Base/TextBlock';
import { useGetUnionsQuery } from '../../../partyApplicationApi';
import { UnionSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';

type Props = {
  texts?: UnionSectionTexts;
};

const UnionOrganizationSelect = ({ texts }: Props) => {
  const { data: unions, isLoading, error } = useGetUnionsQuery();
  return (
    <>
      <Dropdown
        name="unionOrganization"
        label={texts?.unionOrganization?.label || 'Fackförbund'}
        options={unions || []}
        isLoading={isLoading}
      />
      <TextBlock
        type="info"
        text={
          texts?.unionSectionTextBlock ||
          'Ange det fackförbund som är den avtalsbärande organisationen. Det är alltså fackförbundet i kollektivavtalet, inte i fackförbundet som de uppsagda är medlemmar i.'
        }
      />
      {error && (
        <TextBlock
          type="error"
          text="Ett fel uppstod vid hämtning av fackförbund. Vänligen försök igen senare eller kontakta supporten."
        />
      )}
    </>
  );
};

export default UnionOrganizationSelect;
